import { useLang } from 'hooks/lang';
import { isAfter, isBefore } from 'date-fns';

import { Row, DatePicker, Button, IconButton } from 'components/Blocks';
import { CalendarRangeIcon, BoxBetweenLinesIcon, XIcon } from 'components/Icons';

import { FormControlDispatchAction } from 'hooks';

import { formatDate, fromYYYYmmDD, serializeDates } from 'utils/date';

import { LoadConfigState } from './types';

interface ConfigDateRangeProps {
  children?: never;
  state: LoadConfigState;
  dispatch: FormControlDispatchAction<LoadConfigState>;
}

export function ConfigDateRange({ dispatch, state }: ConfigDateRangeProps) {
  const { t } = useLang();

  return (
    <Row justifyContent="center" className="mt-2">
      <CalendarRangeIcon />

      <Row gap="2" fullWidth={false}>
        <div className="relative">
          <DatePicker
            disableFuture
            selected={state.startDate ? fromYYYYmmDD(state.startDate) : undefined}
            disabled={(date) =>
              date && state.endDate ? isAfter(date, fromYYYYmmDD(state.endDate)) : false
            }
            onSelect={(date) =>
              dispatch(
                serializeDates({
                  startDate: date || null,
                }),
              )
            }
          >
            <Button variant="ghost" className="w-[90px] text-sm capitalize">
              {state.startDate ? formatDate(fromYYYYmmDD(state.startDate)) : t('first')}
            </Button>
          </DatePicker>

          {state.startDate && (
            <IconButton
              onClick={() => dispatch({ startDate: null })}
              className="absolute left-1/2 top-0 -translate-x-1/2 animate-out slide-out-to-left-2/4 slide-out-to-top-5 fill-mode-forwards"
            >
              <XIcon size={14} color="destructive" />
            </IconButton>
          )}
        </div>

        <BoxBetweenLinesIcon color="GrayText" />

        <div className="relative">
          <DatePicker
            disableFuture
            selected={state.endDate ? fromYYYYmmDD(state.endDate) : undefined}
            disabled={(date) =>
              date && state.startDate ? isBefore(date, fromYYYYmmDD(state.startDate)) : false
            }
            onSelect={(date) =>
              dispatch(
                serializeDates({
                  endDate: date || null,
                }),
              )
            }
          >
            <Button variant="ghost" className="w-[90px] text-sm">
              {state.endDate ? formatDate(fromYYYYmmDD(state.endDate)) : t('today')}
            </Button>
          </DatePicker>

          {state.endDate && (
            <IconButton
              onClick={() => dispatch({ endDate: null })}
              className="absolute left-1/2 top-0 -translate-x-1/2 animate-out slide-out-to-left-2/4 slide-out-to-top-5 fill-mode-forwards"
              size="small"
            >
              <XIcon size={14} color="destructive" />
            </IconButton>
          )}
        </div>
      </Row>
    </Row>
  );
}
